import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../utils/constants';

export const filterFields = {
  orderRequestID: 'orderRequestID',
  clientIDs: 'clientIDs',
  supplyTypeIDs: 'supplyTypeIDs',
  orderName: 'orderName',
  orderRequestedBy: 'orderRequestedBy',
  statusIDs: 'statusIDs',
  dueDateFrom: 'dueDateFrom',
  dueDateTo: 'dueDateTo',
  isTemplate: 'isTemplate',
  isRecurring: 'isRecurring',
  rushOrder: 'rushOrder'
};
const initialFilterState = {
  orderRequestID: '',
  clientIDs: [],
  supplyTypeIDs: [],
  orderName: '',
  orderRequestedBy: '',
  statusIDs: '',
  dueDateFrom: null,
  dueDateTo: null,
  flags: 0,
  isRecurring: false,
  rushOrder: false
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
};
export const orderRequestSearchsliceName = 'orderRequestSearch';
const orderRequestSlice = createSearchPageSlice({
  sliceName: orderRequestSearchsliceName,
  filterFields,
  initialFilterState,
  initialPageState
});
export const orderRequestActions = orderRequestSlice.actions;
export default orderRequestSlice.reducer;
